import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const FILTER_PARAM_COUNTRY = 'country';
export const FILTER_PARAM_DISTRICT = 'district';
export const FILTER_PARAM_COURSE = 'course';
export const FILTER_PARAM_ORDER_BY = 'orderBy';

export const useFilterParams = () => {
  const location = useLocation();

  return useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const result = {
      [FILTER_PARAM_ORDER_BY]: 'rating' // 'asc' | 'desc' | 'rating'
    };

    if (searchParams.get(FILTER_PARAM_COUNTRY)) {
      result[FILTER_PARAM_COUNTRY] = searchParams.get(FILTER_PARAM_COUNTRY);
    }

    if (parseInt(searchParams.get(FILTER_PARAM_DISTRICT), 10)) {
      result[FILTER_PARAM_DISTRICT] = parseInt(searchParams.get(FILTER_PARAM_DISTRICT), 10);
    }

    if (searchParams.get(FILTER_PARAM_COURSE)) {
      result[FILTER_PARAM_COURSE] = searchParams.get(FILTER_PARAM_COURSE);
    }

    if (searchParams.get(FILTER_PARAM_ORDER_BY)) {
      result[FILTER_PARAM_ORDER_BY] = searchParams.get(FILTER_PARAM_ORDER_BY);
    }

    return result;
  }, [location.search]);
};
